<div class="d-flex">
  <kt-requirement-radio-group
    [selected]="selectedAnswer"
    [question]="question"
    [visible]="visible"
    [options]="options"
    (selectedChange)="selectAnswer($event)"
  >
  </kt-requirement-radio-group>
  <kt-requirement-dry-ice-quantity
    [formGroup]="formGroup"
  ></kt-requirement-dry-ice-quantity>
</div>
